export default {
  roles: [],
  role: {}
}



// WEBPACK FOOTER //
// ./src/components/role/store/state.js